import { Turbo, cable } from "@hotwired/turbo-rails"

export const RELOAD_GUARD_KEY = "cable-session-ended-reload-at"
export const RELOAD_GUARD_MS = 30_000

export function watchSessionEnd(connection, onSessionEnded) {
  const close = connection.close.bind(connection)

  connection.close = (options) => {
    const result = close(options)
    if (options?.allowReconnect === false && connection.isProtocolSupported()) onSessionEnded()
    return result
  }
}

export function reloadForSignIn({ storage = window.sessionStorage, now = Date.now() } = {}) {
  const lastReloadAt = Number(storage.getItem(RELOAD_GUARD_KEY))
  if (lastReloadAt && now - lastReloadAt < RELOAD_GUARD_MS) return false

  storage.setItem(RELOAD_GUARD_KEY, String(now))
  Turbo.visit(window.location.href, { action: "replace" })
  return true
}

export async function installCableSessionGuard() {
  const consumer = await cable.getConsumer()
  watchSessionEnd(consumer.connection, () => reloadForSignIn())
  return consumer
}

installCableSessionGuard()
